<template>
	<swiper :options="swiperOption" class="home-swiper">
		<swiper-slide v-for="(item, index) in list" :key="index" class="home-swiper-item">
			<img :src="item.image" alt="" class="logo" />
			<span class="right">
				<span class="top">{{ item.title }}</span>
				<span class="bottom">
					<span class="price">{{ item.price }}</span>
					<span :class="item.price_zf > 0 ? 'green' : 'red'">
						{{ item.price_zf > 0 ? '+' + item.price_zf : item.price_zf }}%
					</span>
				</span>
			</span>
		</swiper-slide>
	</swiper>
</template>

<script>
export default {
	name: "TickerSwiper",
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		perView: {
			type: Number,
			default: 4, // 一行显示多少个
		},
		space: {
			type: Number,
			default: 10, // 卡片之间的间距
		},
		delay: {
			type: Number,
			default: 2000, // 自动播放间隔
		},
	},
	data() {
		return {
			swiperOption: {
				slidesPerView: this.perView,
				spaceBetween: this.space,
				loop: true,
				autoplay: {
					delay: this.delay,
					disableOnInteraction: false,
				},
				speed: 800,
			},
		};
	},
};
</script>

<style scoped lang="scss">
.home-swiper {
	width: 100%;
	overflow: hidden;

	.home-swiper-item {
		display: flex;
		align-items: center;
		padding: 10px;
		border-radius: 8px;

		img.logo {
			width: 36px;
			height: 36px;
			margin-right: 10px;
		}

		.right {
			display: flex;
			flex-direction: column;
			font-size: 16px;

			.top {
				color: #fff;
				font-size: 18px;
			}

			.bottom {
				display: flex;
				align-items: center;

				.price {
					font-weight: bold;
					margin-right: 6px;
					color: #fff;
				}

				.green {
					color: #0f0;
				}

				.red {
					color: #f00;
				}
			}
		}
	}
}
</style>
